export const deleteLabelInFirstField = (nodes) => nodes.map((node) => {
  const newFields = node.fieldsData.map((field, index) => ({
    ...field,
    label: index !== 0 ? field.label : '',
  }));
  return { ...node, fieldsData: newFields };
});
